import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { DaterangePickerComponent, DaterangepickerConfig} from 'ng2-daterangepicker';
import {ValidatorUtils} from '../../shared/utils/src/validator.utils';

@Component({
    selector: 'app-calendar-picker',
    templateUrl: 'calendar-picker.component.html',
})
export class CalendarPickerComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    @Input() date: string;
    @Input() rsrcId: string;
    @Input() tmznOfs = '+09:00';
    @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();

    preDate = '';
    calendarOption: any = {};

    @ViewChild(DaterangePickerComponent)
    private picker: DaterangePickerComponent;

    constructor(private daterangepickerOptions: DaterangepickerConfig) {
        // datepicker calendar global settings
        this.daterangepickerOptions.skipCSS = true;
    }

    ngOnInit() {
    }

    ngOnChanges(): void {
        this.preDate = this.date;
        // this.preTime = this.time;
    }

    ngAfterViewInit() {
        // calendericker 초기화
        this.initDatePicker();
    }

    ngOnDestroy() {
    }

    initDatePicker() {
        this.calendarOption = {
            singleDatePicker: true,
            locale: { format: 'YYYY-MM-DD' },
            alwaysShowCalendars: false,
            autoUpdateInput: true,
            startDate: moment(this.date)/*,
            minDate: moment().utcOffset(this.tmznOfs)*/
        };

        // 스케쥴 팝업 오픈시에 daterangepicker autofocus가는 현상 수정
        $('app-calendar-picker input').prop('disabled', true);

        setTimeout( () => {
            $('app-calendar-picker input').prop('disabled', false);
        }, 500);
    }

    public selectedDate(event: any) {
        // 캘린더에서 기본 유효성 체크 됨
        this.dateChange.emit(event.start.format('YYYY-MM-DD'));

    }

    public calendarCanceled(e: any) {
        // e.event
        // e.picker
    }

    public calendarApplied(e: any) {
        // e.event
        // e.picker
    }

    onDateChange(event: any) {
        if (event.type === 'keydown') {
            return ValidatorUtils.onlyDate(event);
        } else {
            if (!ValidatorUtils.checkDate(event.target.value)) {
                this.date = this.preDate;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calendar-picker/calendar-picker.component.ts